"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FillGapsExerciseHandler = void 0;
const DefaultCardsExerciseHandler_1 = require("@app/routes/SpeechDevelopment/handlers/DefaultCardsExerciseHandler");
const exercise_js_1 = require("@app/routes/SpeechDevelopment/reducers/exercise.js");
const timer_1 = require("@app/routes/SpeechDevelopment/exersices/Disinhibition/timer");
const audioPlayer_1 = require("@app/services/audioPlayer");
class FillGapsExerciseHandler extends DefaultCardsExerciseHandler_1.DefaultCardsExerciseHandler {
    checkIsCorrectAnswer(answer) {
        var _a;
        return (_a = this.current.correct_options) === null || _a === void 0 ? void 0 : _a.every((e, i) => (e === null || e === void 0 ? void 0 : e.right_word) === answer[i]);
    }
    checkOneGap(index, value) {
        return this.getRightLetter(index) === value;
    }
    getRightLetter(index) {
        var _a;
        return (_a = this.current.correct_options[index]) === null || _a === void 0 ? void 0 : _a.right_word;
    }
    saveAttempt(attemptStr) {
        const recognized = this.recognizedWords.concat([attemptStr]);
        if (recognized.length + 1 <= this.attemptMaxNumber)
            this.dispatch((0, exercise_js_1.setRecognizedWords)(recognized));
    }
    soundTryAgain() {
        audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(this.langId, 318));
    }
    soundRight() {
        audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(this.langId, 'correct'));
    }
    handleWrongAnswer(timeIsOver) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            audioPlayer_1.audioPlayer.stopAudio();
            if (this.recognizedWords.length + 1 === this.attemptMaxNumber || timeIsOver) {
                if (!timeIsOver)
                    (0, timer_1.stopTimer)();
                const nextId = !this.isLast ? (_a = this.data[this.currentIndex + 1]) === null || _a === void 0 ? void 0 : _a.id : undefined;
                this.trackRepEnd(false, nextId);
                this.updateAnswers({ isCorrect: false, isChecked: true, id: this.current.id });
                yield audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(this.langId, 315));
                yield audioPlayer_1.audioPlayer.playAudio('right_audio', this.current.right_audio);
                if (this.isLast) {
                    this.stopExercise();
                    return;
                }
            }
            else
                yield audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(this.langId, 318));
        });
    }
    nextCard() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLast)
                return;
            if ((_a = this.answers[this.currentIndex]) === null || _a === void 0 ? void 0 : _a.isChecked) {
                this.dispatch((0, exercise_js_1.resetRecognizedWords)());
                this.dispatch((0, exercise_js_1.setCurrentIndex)(this.currentIndex + 1));
                return;
            }
            (0, timer_1.stopTimer)();
            this.trackRepEnd(false, (_b = this.data[this.currentIndex + 1]) === null || _b === void 0 ? void 0 : _b.id);
            this.updateAnswers({ isCorrect: false, isChecked: true, id: this.current.id });
            this.dispatch((0, exercise_js_1.resetRecognizedWords)());
            this.dispatch((0, exercise_js_1.setCurrentIndex)(this.currentIndex + 1));
        });
    }
    playCurrentQuestion() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
}
exports.FillGapsExerciseHandler = FillGapsExerciseHandler;
